(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["milky-pharmacies"]) return;
  try {
    
(() => {
  if (window.milkyPharmaciesInitialized) return;
  window.milkyPharmaciesInitialized = true;
  let opener;
  const prepare = (dialog) => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const city = dialog.querySelector('[data-pharmacy-city]');
    const district = dialog.querySelector('[data-pharmacy-district]');
    const entries = [...dialog.querySelectorAll('[data-pharmacy-entry]')];
    const populate = (select, values) => {
      select.length = 1;
      [...new Set(values.filter(Boolean))].sort((a,b) => a.localeCompare(b, 'tr')).forEach(value => select.add(new Option(value, value)));
    };
    const filter = () => {
      let visible = 0;
      entries.forEach(entry => {
        entry.hidden = Boolean((city.value && entry.dataset.city !== city.value) || (district.value && entry.dataset.district !== district.value));
        if (!entry.hidden) visible++;
      });
      dialog.querySelector('[data-pharmacy-no-results]').hidden = !entries.length || visible > 0;
    };
    populate(city, entries.map(entry => entry.dataset.city));
    dialog.querySelector('.milky-pharmacies__filters').hidden = entries.length === 0;
    dialog.querySelector('[data-pharmacy-empty]').hidden = entries.length > 0;
    city.addEventListener('change', () => {
      populate(district, city.value ? entries.filter(entry => entry.dataset.city === city.value).map(entry => entry.dataset.district) : []);
      district.disabled = !city.value;
      filter();
    });
    district.addEventListener('change', filter);
    dialog.querySelector('[data-milky-pharmacy-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-milky-pharmacy-open]');
    if (!trigger) return;
    const dialog = document.getElementById('MilkyPharmacyDialog');
    if (!dialog) return;
    opener = trigger;
    const menu = trigger.closest('header-drawer');
    if (menu) {
      event.preventDefault();
      event.stopPropagation();
      const details = menu.querySelector('details');
      const toggle = details?.querySelector('summary');
      if (details?.open && toggle) {
        toggle.click();
        opener = toggle;
      }
    }
    prepare(dialog);
    dialog.showModal();
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
